import VimeoPlayerLib, { VimeoProps } from '@u-wave/react-vimeo';
import dynamic from 'next/dynamic';

import { useUserAgentContext } from '@/common/contexts/UserAgentContext/useUserAgentContext';

export const VimeoPlayer = (props: VimeoProps) => {
  const { isIosOrSafari } = useUserAgentContext();

  return isIosOrSafari ? ( // make sure that component is reloaded
    <VimeoPlayerLib
      controls={true} // display controls for ios users to be able to play the video
      dnt={true}
      loop={true}
      muted={true}
      responsive
      {...props}
    />
  ) : (
    <VimeoPlayerLib dnt={true} loop={true} muted={true} responsive {...props} />
  );
};

export const DynamicVimeo = dynamic(
  () => import('@/common/components/VimeoPlayer/VimeoPlayer').then((module) => module.VimeoPlayer),
  { ssr: false },
);

export default DynamicVimeo;
